"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _help_1_ = _interopRequireDefault(require("../images/help_1_3.gif"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-unescaped-entities */
var party = {
  id: "party",
  title: {
    en: "Lesson 3 (Party)",
    de: "Lektion 3 (Party)"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      src: _help_1_.default,
      alt: "",
      style: {
        width: "390px",
        height: "274px",
        display: "block",
        margin: "16px auto"
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Use of Party"), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, "During play party hunting is a system that will help you to have more fun."), /*#__PURE__*/_react.default.createElement("li", null, "When you are assembling your party, make sure you are strengthening your weakness by obtaining a class that will help your weakness. Remember that 1+1 is not just 2 but it could be 3 or 4 type of result."), /*#__PURE__*/_react.default.createElement("li", null, "When you are creating your party, press shortcut key P to insert the name of your party and push the create tab and it will create a party. It only works when the party is not yet created."), /*#__PURE__*/_react.default.createElement("li", null, "When you want to enjoy another of Ferentus' features, click on the invite button and wait for other people to accept. When they do accept your invitation, that party can join and play in party mode."), /*#__PURE__*/_react.default.createElement("li", null, "In party mode each character will gain party experience, and depending on party experience, party level will either rise or drop."), /*#__PURE__*/_react.default.createElement("li", null, "During party hunting, depending on Lv of the item(s), money and Exp will vary, and also distribution of items go according to the order.")))
  }
};
var _default = party;
exports.default = _default;